import { openInlineOpportunityForCampaign } from '@bingads-webui-campaign-legacy/inline-opportunity/view/panel-manager';

/**
    * show inline opportunity, and bind all related actions including apply/cancel
    * todo: update it after migrate budget landscape part
    *
    * @param {Object} event - The backbone click event from where the quality score cell was clicked.
    * @param {Object} campaign - campaign entity that triggered this call, currently this status should only happen in campagin grid
    * @param {Object} grid - projection grid instance
    * @param {Boolean} isForVNext - Is new ui or not.
    * @param {Object} perfMarker performance marker
    * @returns {undefined}.
  */
export function openInlineOpportunitiesPanel(event, campaign, grid, isForVNext, perfMarker) {
  event.stopImmediatePropagation();

  openInlineOpportunityForCampaign(event, campaign.Id, campaign.Name, isForVNext, perfMarker);
}
